import { apiRequest } from "../apiRequest";

export async function postConnectAccountLink(): Promise<string> {
  const { url } = await apiRequest<{ url: string }>({ url: "stripe/connect/accountLink", method: "POST" });
  return url;
}
